function openPrint(html) {
    const win = window.open('', '_blank', 'width=700,height=800,left=80,top=40');
    if (!win) {
        alert('Print blocked!\n\nClick the popup blocked icon in the Chrome address bar → Select "Always allow popups from localhost" → Reload the page → Try again.');
        return;
    }
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); }, 600);
}

const SLIP_CSS = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Courier New', monospace; width: 340px; margin: 0 auto; font-size: 13px; font-weight: 700; color: #000; padding: 10px 12px; background: #fff; }
  .center { text-align: center; }
  .line { border-top: 2px solid #000; margin: 7px 0; }
  .dashed { border-top: 2px dashed #000; margin: 7px 0; }
  .row { display: flex; justify-content: space-between; align-items: center; margin: 5px 0; }
  .order-box { border: 3px solid #000; padding: 6px 10px; margin: 7px 0; text-align: center; }
  .mrn-box { border: 3px solid #000; padding: 6px 10px; margin: 7px 0; text-align: center; }
  .xlarge { font-size: 24px; letter-spacing: 2px; font-weight: 900; }
  .test-row { padding: 5px 0; border-bottom: 2px dashed #000; display: flex; justify-content: space-between; align-items: center; }
  .barcode-wrap { text-align: center; margin: 6px 0; }
  .barcode-wrap svg { max-width: 100%; }
  @media print { body { margin: 0 auto; width: 80mm; } @page { size: 80mm auto; margin: 2mm; } }
`;

const JSBARCODE_SCRIPT = `<script src="${window.location.origin}/jsbarcode.min.js"><\/script>`;

function barcodeBlock(id, value) {
    return `
  <div class="barcode-wrap">
    <svg id="${id}"></svg>
  </div>
  <script>
    (function() {
      function tryBarcode() {
        if (typeof JsBarcode === 'undefined') { setTimeout(tryBarcode, 100); return; }
        try { JsBarcode('#${id}', '${value}', { format:'CODE128', width:1.8, height:28, displayValue:true, fontSize:9, margin:4, textMargin:1 }); } catch(e) {}
      }
      tryBarcode();
    })();
  <\/script>`;
}

function header(title) {
    return `
  <div class="center">
    <div style="font-size:20px; font-weight:900; letter-spacing:1px;">&#127973; City Hospital</div>
    <div style="font-size:12px; font-weight:700;">Hospital Information Management System</div>
    <div style="font-size:12px; font-weight:700;">${title}</div>
  </div>`;
}

export function printPatientSlip(patient, department = '', visitDetails = {}, tokenNumber = null) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<style>${SLIP_CSS}</style></head><body>
  ${header('Patient Registration Slip')}
  <div class="line"></div>
  ${department ? `<div class="center" style="font-size:14px; font-weight:900; margin:4px 0; letter-spacing:1px;">[ ${department.toUpperCase()} ]</div>` : ''}
  <div class="mrn-box">
    <div style="font-size:11px; font-weight:700;">MRN / Patient ID</div>
    <div class="xlarge">${patient.mrn || '—'}</div>
  </div>
  ${patient.mrn ? barcodeBlock('bc-mrn', patient.mrn) : ''}
  ${tokenNumber ? `
  <div class="order-box" style="border:3px solid #000; margin:7px 0; text-align:center;">
    <div style="font-size:11px; font-weight:700; letter-spacing:1px;">QUEUE TOKEN</div>
    <div style="font-size:28px; font-weight:900; letter-spacing:3px;">${tokenNumber}</div>
  </div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Name:</span><span>${patient.full_name || '—'}</span></div>
  ${patient.father_name ? `<div class="row"><span>Father/Husband:</span><span>${patient.father_name}</span></div>` : ''}
  <div class="row"><span>Gender:</span><span>${patient.gender || '—'}</span></div>
  <div class="row"><span>Age:</span><span>${patient.age_years ? patient.age_years + ' Years' : '—'}</span></div>
  ${patient.phone ? `<div class="row"><span>Phone:</span><span>${patient.phone}</span></div>` : ''}
  ${patient.cnic ? `<div class="row"><span>CNIC:</span><span>${patient.cnic}</span></div>` : ''}
  ${visitDetails.complaint ? `<div class="dashed"></div><div class="row"><span>Complaint:</span><span>${visitDetails.complaint}</span></div>` : ''}
  ${visitDetails.department ? `<div class="row"><span>Referred To:</span><span>${visitDetails.department}</span></div>` : ''}
  ${visitDetails.doctor ? `<div class="row"><span>Doctor:</span><span>${visitDetails.doctor}</span></div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Date:</span><span>${date}</span></div>
  <div class="row"><span>Time:</span><span>${time}</span></div>
  <div class="line"></div>
  <div class="center" style="font-size:12px; font-weight:700; margin-top:4px;">Please keep this slip safe</div>
  <div class="center" style="font-size:12px; font-weight:700;">Show at every department visit</div>
  <div class="center" style="font-size:11px; margin-top:6px;">City Hospital — Hospital Information Management System</div>
</body></html>`;
    openPrint(html);
}

export function printLabOrderSlip(patient, orderNumber, tests = [], orderDetails = {}, tokenNumber = null, discountPercent = 0) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });

    const subtotal = tests.reduce((sum, t) => sum + (parseFloat(t.price) || 0), 0);
    const discountAmt = subtotal * (parseFloat(discountPercent) || 0) / 100;
    const netTotal = subtotal - discountAmt;

    const testsHTML = tests.map(t => `
      <div style="padding: 5px 0; border-bottom: 2px dashed #000;">
        <div style="font-weight:900; font-size:13px;">${t.test_name || t}</div>
        <div style="display:flex; justify-content:space-between; align-items:center; margin-top:2px;">
          <span style="font-size:11px; font-weight:700; color:#333;">${t.test_code || ''}${t.specimen_type ? ' | ' + t.specimen_type : ''}</span>
          ${parseFloat(t.price) > 0 ? `<span style="font-size:12px; font-weight:900;">Rs. ${parseFloat(t.price).toFixed(0)}</span>` : '<span style="font-size:11px;">—</span>'}
        </div>
      </div>`).join('');

    const billingHTML = subtotal > 0 ? `
  <div class="dashed"></div>
  <div style="font-weight:900; font-size:12px; margin-bottom:4px;">BILLING SUMMARY</div>
  <div class="row"><span>Subtotal:</span><span>Rs. ${subtotal.toFixed(0)}</span></div>
  ${discountAmt > 0 ? `<div class="row"><span>Discount (${discountPercent}%):</span><span>- Rs. ${discountAmt.toFixed(0)}</span></div>` : ''}
  <div class="dashed"></div>
  <div class="row" style="font-size:14px; font-weight:900;"><span>NET TOTAL:</span><span>Rs. ${netTotal.toFixed(0)}</span></div>` : '';

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<style>${SLIP_CSS}</style></head><body>
  ${header('Laboratory Order Slip')}
  <div class="line"></div>
  <div class="order-box">
    <div style="font-size:11px; font-weight:700;">Order Number</div>
    <div style="font-size:18px; font-weight:900; letter-spacing:1px;">${orderNumber}</div>
    <div style="font-size:12px; font-weight:700;">${orderDetails.priority || 'Routine'} | ${orderDetails.source || 'OPD'}</div>
  </div>
  ${orderNumber ? barcodeBlock('bc-order', orderNumber) : ''}
  ${tokenNumber ? `
  <div class="order-box" style="border:3px solid #000; margin:7px 0; text-align:center;">
    <div style="font-size:11px; font-weight:700; letter-spacing:1px;">QUEUE TOKEN</div>
    <div style="font-size:28px; font-weight:900; letter-spacing:3px;">${tokenNumber}</div>
  </div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Name:</span><span>${patient.full_name || '—'}</span></div>
  <div class="row"><span>MRN:</span><span>${patient.mrn || '—'}</span></div>
  <div class="row"><span>Gender:</span><span>${patient.gender || '—'}</span></div>
  <div class="row"><span>Age:</span><span>${patient.age_years ? patient.age_years + ' Yrs' : '—'}</span></div>
  ${patient.phone ? `<div class="row"><span>Phone:</span><span>${patient.phone}</span></div>` : ''}
  ${orderDetails.clinical_info ? `<div class="dashed"></div><div style="font-size:12px; font-weight:700;">Clinical Info:</div><div style="font-size:12px; font-weight:700; margin-top:2px;">${orderDetails.clinical_info}</div>` : ''}
  <div class="dashed"></div>
  <div style="font-weight:900; margin-bottom:4px;">Tests Ordered (${tests.length}):</div>
  ${testsHTML || '<div style="font-size:12px;">No tests</div>'}
  ${billingHTML}
  <div class="dashed"></div>
  <div class="row"><span>Date:</span><span>${date}</span></div>
  <div class="row"><span>Time:</span><span>${time}</span></div>
  <div class="line"></div>
  <div class="center" style="font-size:11px; margin-top:4px;">City Hospital — Hospital Information Management System</div>
</body></html>`;
    openPrint(html);
}

export function printRadiologyOrderSlip(patient, orderNumber, tests = [], orderDetails = {}, tokenNumber = null) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });

    const testsHTML = tests.map(t => `
      <div class="test-row">
        <span>${t.test_name || t}</span>
        <span style="font-size:11px;">${t.modality || ''} ${t.body_part ? '| ' + t.body_part : ''}</span>
      </div>`).join('');

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<style>${SLIP_CSS}</style></head><body>
  ${header('Radiology Order Slip')}
  <div class="line"></div>
  <div class="order-box">
    <div style="font-size:11px; font-weight:700;">Order Number</div>
    <div style="font-size:18px; font-weight:900; letter-spacing:1px;">${orderNumber}</div>
    <div style="font-size:12px; font-weight:700;">${orderDetails.priority || 'Routine'} | ${orderDetails.source || 'OPD'}</div>
  </div>
  ${orderNumber ? barcodeBlock('bc-rad-order', orderNumber) : ''}
  ${tokenNumber ? `
  <div class="order-box" style="border:3px solid #000; margin:7px 0; text-align:center;">
    <div style="font-size:11px; font-weight:700; letter-spacing:1px;">QUEUE TOKEN</div>
    <div style="font-size:28px; font-weight:900; letter-spacing:3px;">${tokenNumber}</div>
  </div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Name:</span><span>${patient.full_name || '—'}</span></div>
  <div class="row"><span>MRN:</span><span>${patient.mrn || '—'}</span></div>
  <div class="row"><span>Gender:</span><span>${patient.gender || '—'}</span></div>
  <div class="row"><span>Age:</span><span>${patient.age_years ? patient.age_years + ' Yrs' : '—'}</span></div>
  ${patient.phone ? `<div class="row"><span>Phone:</span><span>${patient.phone}</span></div>` : ''}
  ${orderDetails.clinical_info ? `<div class="dashed"></div><div style="font-size:12px; font-weight:700;">Clinical Info:</div><div style="font-size:12px; font-weight:700; margin-top:2px;">${orderDetails.clinical_info}</div>` : ''}
  <div class="dashed"></div>
  <div style="font-weight:900; margin-bottom:4px;">Exam Ordered:</div>
  ${testsHTML || '<div style="font-size:12px;">No exam selected</div>'}
  <div class="dashed"></div>
  <div class="row"><span>Date:</span><span>${date}</span></div>
  <div class="row"><span>Time:</span><span>${time}</span></div>
  <div class="line"></div>
  <div class="center" style="font-size:11px; margin-top:4px;">City Hospital — Hospital Information Management System</div>
</body></html>`;
    openPrint(html);
}

export function printLabResultReport(patient, orderNumber, orderDetails = {}, results = []) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });

    // B&W friendly flags (no color dependency)
    const FLAG_LABEL = { High: '↑ H', Low: '↓ L', Critical: '!! CRIT', Normal: 'N' };
    const FLAG_BOLD  = { High: true, Low: true, Critical: true, Normal: false };

    const resultsHTML = results.map(r => {
        if (r._header) {
            return `
      <tr style="background:#1e3a5f;">
        <td colspan="5" style="padding:7px 10px; font-size:12px; font-weight:700; color:white; letter-spacing:0.5px;">
          ${r.test_name || ''}${r.specimen_type ? ' &nbsp;|&nbsp; Specimen: ' + r.specimen_type : ''}
        </td>
      </tr>`;
        }
        const flag = r.result_flag || 'Normal';
        const isAbnormal = flag !== 'Normal';
        const isCrit = flag === 'Critical';
        const indent = r._subparam ? 'padding-left:24px;' : '';
        return `
      <tr style="border-bottom:1px solid #e5e7eb; background:${isCrit ? '#f5f5f5' : '#fff'};">
        <td style="padding:6px 10px; font-size:12px; font-weight:${isAbnormal ? '700' : '500'}; ${indent}">${r.test_name || '—'}</td>
        <td style="padding:6px 10px; font-size:13px; font-weight:${isAbnormal ? '900' : '600'};">${r.result_value || '—'}</td>
        <td style="padding:6px 10px; font-size:12px; color:#374151;">${r.result_unit || '—'}</td>
        <td style="padding:6px 10px; font-size:12px; color:#374151;">${r.normal_range || '—'}</td>
        <td style="padding:6px 10px; text-align:center;">
          <span style="font-size:11px; font-weight:${FLAG_BOLD[flag] ? '900' : '500'}; padding:2px 8px; border:1px solid #374151; border-radius:3px;">${FLAG_LABEL[flag] || flag}</span>
        </td>
      </tr>`;
    }).join('');

    const reportCSS = `
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; padding: 20px; color: #111; background: #fff; font-size: 13px; }
      .header { text-align:center; border-bottom:3px solid #0369a1; padding-bottom:12px; margin-bottom:16px; }
      .hospital-name { font-size:22px; font-weight:900; color:#0369a1; letter-spacing:1px; }
      .report-title { font-size:15px; font-weight:700; color:#1e3a5f; margin-top:4px; letter-spacing:2px; text-transform:uppercase; }
      .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px 20px; background:#eff6ff; border:1px solid #bfdbfe; border-radius:8px; padding:14px; margin-bottom:16px; }
      .info-item .label { font-size:10px; font-weight:700; color:#0369a1; text-transform:uppercase; }
      .info-item .value { font-size:13px; font-weight:600; color:#1e293b; margin-top:2px; }
      .stat-badge { display:inline-block; background:#dc2626; color:white; font-size:11px; font-weight:900; padding:3px 10px; border-radius:4px; letter-spacing:1px; }
      table { width:100%; border-collapse:collapse; margin-bottom:20px; }
      thead { background:#1e3a5f; color:white; }
      thead th { padding:9px 10px; text-align:left; font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.5px; }
      .footer { border-top:2px solid #e2e8f0; padding-top:14px; display:grid; grid-template-columns:1fr 1fr 1fr; gap:20px; margin-top:10px; }
      .sig-line { border-top:1px solid #374151; padding-top:4px; text-align:center; font-size:11px; color:#374151; margin-top:30px; }
      @media print { @page { size: A4; margin: 12mm; } body { padding: 0; } }
    `;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<title>Lab Report — ${orderNumber}</title><style>${reportCSS}</style></head><body>
  <div class="header">
    <div class="hospital-name">&#127973; City Hospital</div>
    <div class="report-title">Laboratory Investigation Report</div>
    <div style="font-size:12px; color:#64748b; margin-top:4px;">Report Date: ${date} &nbsp;|&nbsp; Time: ${time}</div>
  </div>

  <div class="info-grid">
    <div class="info-item"><div class="label">Patient Name</div><div class="value">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="label">MRN</div><div class="value">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="label">Age / Gender</div><div class="value">${patient.age_years ? patient.age_years + ' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="label">Phone</div><div class="value">${patient.phone || '—'}</div></div>
    <div class="info-item"><div class="label">Order Number</div><div class="value">${orderNumber}</div></div>
    <div class="info-item" style="grid-column:1/-1;">${orderNumber ? barcodeBlock('bc-lab-result', orderNumber) : ''}</div>
    <div class="info-item"><div class="label">Priority</div><div class="value">${orderDetails.priority === 'STAT' ? '<span class="stat-badge">🚨 STAT</span>' : orderDetails.priority || 'Routine'}</div></div>
    <div class="info-item"><div class="label">Source</div><div class="value">${orderDetails.source || 'OPD'}</div></div>
    <div class="info-item"><div class="label">Order Date &amp; Time</div><div class="value">${orderDetails.order_time ? new Date(orderDetails.order_time).toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' }) + ' ' + new Date(orderDetails.order_time).toLocaleTimeString('en-PK', { hour:'2-digit', minute:'2-digit', hour12:true }) : date + ' ' + time}</div></div>
    ${orderDetails.clinical_info ? `<div class="info-item" style="grid-column:1/-1;"><div class="label">Clinical Information</div><div class="value">${orderDetails.clinical_info}</div></div>` : ''}
  </div>

  <table>
    <thead>
      <tr>
        <th>Test Name</th>
        <th>Result</th>
        <th>Unit</th>
        <th>Reference Range</th>
        <th style="text-align:center;">Flag</th>
      </tr>
    </thead>
    <tbody>
      ${resultsHTML || '<tr><td colspan="5" style="padding:20px; text-align:center; color:#94a3b8;">No results</td></tr>'}
    </tbody>
  </table>

  <div class="footer">
    <div><div class="sig-line">Lab Technician</div></div>
    <div><div class="sig-line">Lab In-Charge</div></div>
    <div><div class="sig-line">Pathologist / Consultant</div></div>
  </div>
  <div style="text-align:center; font-size:11px; color:#94a3b8; margin-top:16px;">This report is generated by City Hospital. For queries contact the laboratory.</div>

  ${patient.phone ? `
  <div style="text-align:center; margin-top:20px; border-top:1px solid #e2e8f0; padding-top:16px;">
    <p style="font-size:12px; color:#374151; margin-bottom:10px;">Share results with patient via WhatsApp:</p>
    <a href="https://wa.me/${patient.phone.replace(/[^0-9]/g,'')}?text=${encodeURIComponent(
      `*Lab Results — City Hospital*\n` +
      `Patient: ${patient.full_name} (MRN: ${patient.mrn})\n` +
      `Order: ${orderNumber}\n` +
      `Date: ${date}\n\n` +
      results.map(r => `• ${r.test_name}: ${r.result_value || '—'} ${r.result_unit || ''} [${r.result_flag || 'Normal'}]`).join('\n') +
      `\n\nFor queries contact the laboratory.`
    )}" target="_blank"
      style="display:inline-block; background:#25d366; color:white; padding:10px 24px; border-radius:8px; font-weight:700; font-size:13px; text-decoration:none; letter-spacing:0.5px;">
      📱 Share on WhatsApp
    </a>
  </div>` : ''}
</body></html>`;
    openPrint(html);
}

export function printComparativeReport(patient, currentOrder, currentResults, historyData) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit', hour12: true });

    // Group history by order, pick last 2 previous orders
    const orderMap = {};
    historyData.forEach(r => {
        if (r.order_number === currentOrder.order_number) return;
        if (!r.result_value) return;
        if (!orderMap[r.order_number]) orderMap[r.order_number] = { order_number: r.order_number, order_time: r.order_time, items: {} };
        orderMap[r.order_number].items[r.test_name] = r;
    });
    const prevOrders = Object.values(orderMap).sort((a, b) => new Date(b.order_time) - new Date(a.order_time)).slice(0, 2);

    const fmtDate = (ts) => ts ? new Date(ts).toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

    const colHeaders = [
        `<th>Current<br><small>${fmtDate(currentOrder.order_time)}<br>${currentOrder.order_number}</small></th>`,
        ...prevOrders.map(o => `<th>Previous<br><small>${fmtDate(o.order_time)}<br>${o.order_number}</small></th>`)
    ].join('');

    const rows = currentResults.map(r => {
        const isAb = r.result_flag && r.result_flag !== 'Normal';
        const prevCols = prevOrders.map(o => {
            const prev = o.items[r.test_name];
            if (!prev) return `<td style="color:#94a3b8; text-align:center;">—</td>`;
            const pAb = prev.result_flag && prev.result_flag !== 'Normal';
            return `<td style="text-align:center; font-weight:600; color:${pAb ? '#dc2626' : '#111'};">${prev.result_value} ${prev.result_unit || ''}</td>`;
        }).join('');
        return `
        <tr style="border-bottom:1px solid #f1f5f9; background:${isAb ? '#fff5f5' : 'white'}">
            <td style="padding:8px 10px; font-weight:600;">${r.test_name}</td>
            <td style="padding:8px 10px; color:#64748b; font-size:11px;">${r.specimen_type || '—'}</td>
            <td style="padding:8px 10px; color:#64748b; font-size:11px;">${r.normal_range || '—'}</td>
            <td style="padding:8px 10px; text-align:center; font-weight:700; color:${isAb ? '#dc2626' : '#16a34a'};">${r.result_value} ${r.result_unit || ''}</td>
            ${prevCols}
            <td style="padding:8px 10px; text-align:center;">
                <span style="background:${isAb ? '#fee2e2' : '#dcfce7'}; color:${isAb ? '#dc2626' : '#16a34a'}; padding:2px 8px; border-radius:10px; font-size:11px; font-weight:700;">
                    ${r.result_flag || 'Normal'}
                </span>
            </td>
        </tr>`;
    }).join('');

    const css = `
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family:Arial,sans-serif; max-width:850px; margin:0 auto; padding:20px; color:#111; font-size:13px; }
      .header { text-align:center; border-bottom:3px solid #7c3aed; padding-bottom:12px; margin-bottom:16px; }
      .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px 20px; background:#f5f3ff; border:1px solid #c4b5fd; border-radius:8px; padding:14px; margin-bottom:16px; }
      .lbl { font-size:10px; font-weight:700; color:#7c3aed; text-transform:uppercase; }
      .val { font-size:13px; font-weight:600; margin-top:2px; }
      table { width:100%; border-collapse:collapse; }
      thead { background:#1e3a5f; color:white; }
      thead th { padding:9px 10px; text-align:left; font-size:11px; font-weight:700; text-transform:uppercase; }
      .footer { display:grid; grid-template-columns:1fr 1fr 1fr; gap:20px; margin-top:40px; border-top:2px solid #e2e8f0; padding-top:14px; }
      .sig { border-top:1px solid #374151; padding-top:4px; text-align:center; font-size:11px; margin-top:30px; }
      @media print { @page { size:A4 landscape; margin:10mm; } body { padding:0; } }
    `;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Comparative Report — ${currentOrder.order_number}</title><style>${css}</style></head><body>
    <div class="header">
        <div style="font-size:22px; font-weight:900; color:#7c3aed;">🏥 City Hospital</div>
        <div style="font-size:15px; font-weight:700; margin-top:4px; letter-spacing:2px;">COMPARATIVE LAB REPORT</div>
        <div style="font-size:12px; color:#64748b; margin-top:4px;">Printed: ${date} at ${time}</div>
    </div>
    <div class="info-grid">
        <div><div class="lbl">Patient Name</div><div class="val">${patient.full_name || '—'}</div></div>
        <div><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
        <div><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years + ' yrs' : '—'} / ${patient.gender || '—'}</div></div>
        <div><div class="lbl">Phone</div><div class="val">${patient.phone || '—'}</div></div>
    </div>
    ${prevOrders.length === 0 ? `<div style="background:#fef3c7; border:1px solid #fcd34d; border-radius:8px; padding:12px 16px; margin-bottom:16px; color:#92400e; font-weight:600;">⚠️ No previous results found — showing current report only.</div>` : ''}
    <table>
        <thead>
            <tr>
                <th>Test</th>
                <th>Specimen</th>
                <th>Reference Range</th>
                ${colHeaders}
                <th>Flag</th>
            </tr>
        </thead>
        <tbody>${rows}</tbody>
    </table>
    <div class="footer">
        <div><div class="sig">Lab Technician</div></div>
        <div><div class="sig">Lab In-Charge</div></div>
        <div><div class="sig">Pathologist / Consultant</div></div>
    </div>
    <div style="text-align:center; font-size:11px; color:#94a3b8; margin-top:16px;">This comparative report is generated by City Hospital. For queries contact the laboratory.</div>
</body></html>`;
    openPrint(html);
}

const A4_CSS = `
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; padding: 24px; color: #111; background: #fff; font-size: 13px; }
  .a4-header { text-align:center; border-bottom:3px solid #1e3a5f; padding-bottom:14px; margin-bottom:18px; }
  .hospital-name { font-size:22px; font-weight:900; color:#1e3a5f; letter-spacing:1px; }
  .doc-title { font-size:16px; font-weight:700; color:#374151; margin-top:6px; text-transform:uppercase; letter-spacing:2px; }
  .info-grid { display:grid; grid-template-columns:1fr 1fr; gap:8px 24px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:8px; padding:14px; margin-bottom:18px; }
  .info-item .lbl { font-size:10px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:0.5px; }
  .info-item .val { font-size:13px; font-weight:600; color:#1e293b; margin-top:2px; }
  .section { margin-bottom:16px; }
  .section-title { font-size:11px; font-weight:700; color:#fff; background:#1e3a5f; padding:4px 10px; text-transform:uppercase; letter-spacing:.5px; margin-bottom:10px; }
  .sig-row { display:grid; grid-template-columns:1fr 1fr 1fr; gap:30px; margin-top:40px; }
  .sig-box { border-top:1px solid #374151; padding-top:6px; text-align:center; font-size:11px; color:#374151; }
  .sig-box-2 { display:grid; grid-template-columns:1fr 1fr; gap:30px; margin-top:40px; }
  .footer-note { text-align:center; font-size:11px; color:#94a3b8; margin-top:18px; border-top:1px solid #e2e8f0; padding-top:10px; }
  .ae-badge { display:inline-block; background:#991b1b; color:white; font-size:12px; font-weight:900; padding:4px 14px; border-radius:5px; letter-spacing:1px; }
  @media print { @page { size: A4; margin: 12mm; } body { padding: 0; } }
`;

function a4Header(title, subtitle) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour:'2-digit', minute:'2-digit' });
    return `
    <div class="a4-header">
      <div class="hospital-name">🏥 City Hospital</div>
      <div class="doc-title">${title}</div>
      ${subtitle ? `<div style="font-size:12px;color:#64748b;margin-top:4px;">${subtitle}</div>` : ''}
      <div style="font-size:11px;color:#94a3b8;margin-top:4px;">Printed: ${date} at ${time}</div>
    </div>`;
}

export function printAEDischargeSummary(patient, visit, form = {}) {
    const arrivalDate = visit.arrival_time ? new Date(visit.arrival_time).toLocaleString('en-PK') : '—';
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>A&E Discharge Summary</title><style>${A4_CSS}</style></head><body>
  ${a4Header('A&E Discharge Summary', `A&E No: ${visit.ae_number || '—'}`)}
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Patient Name</div><div class="val">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years+' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">Phone</div><div class="val">${patient.phone || '—'}</div></div>
    <div class="info-item"><div class="lbl">Arrival Time</div><div class="val">${arrivalDate}</div></div>
    <div class="info-item"><div class="lbl">Triage Level</div><div class="val">T${visit.triage_level || '—'} — ${visit.triage_category || '—'}</div></div>
    <div class="info-item"><div class="lbl">Chief Complaint</div><div class="val">${visit.chief_complaint || '—'}</div></div>
    <div class="info-item"><div class="lbl">Arrival Mode</div><div class="val">${visit.arrival_mode || '—'}</div></div>
  </div>
  <div class="section">
    <div class="section-title">Clinical Details</div>
    <table style="width:100%;border-collapse:collapse;">
      <tr><td style="padding:6px 0;width:200px;font-weight:700;color:#374151;">Diagnosis:</td><td style="padding:6px 0;">${form.diagnosis || '—'}</td></tr>
      <tr><td style="padding:6px 0;font-weight:700;color:#374151;">Treatment Given:</td><td style="padding:6px 0;">${form.treatment || '—'}</td></tr>
      <tr><td style="padding:6px 0;font-weight:700;color:#374151;">Discharge Condition:</td><td style="padding:6px 0;">${form.condition || '—'}</td></tr>
      <tr><td style="padding:6px 0;font-weight:700;color:#374151;">Follow-up Instructions:</td><td style="padding:6px 0;">${form.followup || '—'}</td></tr>
    </table>
  </div>
  <div class="sig-row">
    <div><div class="sig-box">A&E Doctor</div></div>
    <div><div class="sig-box">Nurse In-Charge</div></div>
    <div><div class="sig-box">Patient / Attendant</div></div>
  </div>
  <div class="footer-note">This document is generated by City Hospital — A&E Module</div>
</body></html>`;
    openPrint(html);
}

export function printLAMAConsent(patient, visit) {
    const now = new Date().toLocaleString('en-PK');
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>LAMA Consent</title><style>${A4_CSS}</style></head><body>
  ${a4Header('LAMA Consent Form', 'Left Against Medical Advice')}
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Patient Name</div><div class="val">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">A&E No.</div><div class="val">${visit.ae_number || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years+' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">CNIC</div><div class="val">${patient.cnic || '—'}</div></div>
    <div class="info-item"><div class="lbl">Date / Time</div><div class="val">${now}</div></div>
  </div>
  <div class="section">
    <div class="section-title">Declaration</div>
    <p style="line-height:1.8;font-size:13px;margin-bottom:12px;">
      I, <strong>${patient.full_name || '________________'}</strong>, CNIC: <strong>${patient.cnic || '________________'}</strong>,
      hereby state that I have been examined and assessed by the Emergency Department physicians at this hospital.
      I have been advised that my condition requires medical treatment and that leaving at this time may pose a risk to my health and life.
    </p>
    <p style="line-height:1.8;font-size:13px;margin-bottom:12px;">
      Despite this advice, I have decided to leave the hospital against medical advice. I take full responsibility for any
      consequences of this decision and absolve the hospital, doctors, nurses, and staff of any liability arising from my departure.
    </p>
    <p style="line-height:1.8;font-size:13px;">
      I confirm that I have understood the risks explained to me and that I am making this decision of my own free will.
    </p>
  </div>
  <div class="section">
    <div class="section-title">Reason for Leaving (if given)</div>
    <div style="border:1px solid #e2e8f0;border-radius:6px;padding:12px;min-height:60px;">&nbsp;</div>
  </div>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:30px;margin-top:40px;">
    <div><div class="sig-box">Patient / Attendant Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">A&E Doctor Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Witness Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Nurse In-Charge<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
  </div>
  <div class="footer-note">City Hospital — LAMA Consent Form | Keep original on file</div>
</body></html>`;
    openPrint(html);
}

export function printDAMAConsent(patient, visit) {
    const now = new Date().toLocaleString('en-PK');
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>DAMA Consent</title><style>${A4_CSS}</style></head><body>
  ${a4Header('DAMA Consent Form', 'Discharged Against Medical Advice')}
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Patient Name</div><div class="val">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">A&E No.</div><div class="val">${visit.ae_number || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years+' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">CNIC</div><div class="val">${patient.cnic || '—'}</div></div>
    <div class="info-item"><div class="lbl">Date / Time</div><div class="val">${now}</div></div>
  </div>
  <div class="section">
    <div class="section-title">Declaration</div>
    <p style="line-height:1.8;font-size:13px;margin-bottom:12px;">
      I, <strong>${patient.full_name || '________________'}</strong>, CNIC: <strong>${patient.cnic || '________________'}</strong>,
      hereby request early discharge from the Emergency Department. I have been informed that the treating medical team
      recommends continued treatment and monitoring. I understand the risks of early discharge and take full responsibility.
    </p>
    <p style="line-height:1.8;font-size:13px;">
      I hereby discharge the hospital and all medical staff from any liability related to any adverse outcome resulting
      from this early discharge.
    </p>
  </div>
  <div class="section">
    <div class="section-title">Reason for Early Discharge</div>
    <div style="border:1px solid #e2e8f0;border-radius:6px;padding:12px;min-height:60px;">&nbsp;</div>
  </div>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:30px;margin-top:40px;">
    <div><div class="sig-box">Patient / Attendant Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">A&E Doctor Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Witness Signature<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Nurse In-Charge<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
  </div>
  <div class="footer-note">City Hospital — DAMA Consent Form | Keep original on file</div>
</body></html>`;
    openPrint(html);
}

export function printAEDeathCertificate(patient, visit, form = {}) {
    const now = new Date().toLocaleString('en-PK');
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Death Certificate</title><style>${A4_CSS}</style></head><body>
  ${a4Header('Death Certificate / MLC Intimation', `A&E No: ${visit.ae_number || '—'}`)}
  <div style="background:#fef2f2;border:2px solid #dc2626;border-radius:8px;padding:10px 16px;margin-bottom:16px;text-align:center;">
    <span style="font-weight:900;color:#dc2626;font-size:13px;letter-spacing:1px;">MEDICO-LEGAL DOCUMENT — CONFIDENTIAL</span>
  </div>
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Deceased Name</div><div class="val">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years+' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">CNIC</div><div class="val">${patient.cnic || '—'}</div></div>
    <div class="info-item"><div class="lbl">Arrival Time</div><div class="val">${visit.arrival_time ? new Date(visit.arrival_time).toLocaleString('en-PK') : '—'}</div></div>
    <div class="info-item"><div class="lbl">Time of Death</div><div class="val">${form.death_time || '—'}</div></div>
    <div class="info-item"><div class="lbl">A&E Number</div><div class="val">${visit.ae_number || '—'}</div></div>
    <div class="info-item"><div class="lbl">MLC Number</div><div class="val">${visit.mlc_number || (visit.is_mlc ? 'MLC-'+visit.ae_number : 'N/A')}</div></div>
  </div>
  <div class="section">
    <div class="section-title">Cause of Death</div>
    <table style="width:100%;border-collapse:collapse;">
      <tr><td style="padding:7px 0;width:220px;font-weight:700;color:#374151;">Immediate Cause:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.cause_immediate || '&nbsp;'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Antecedent Cause:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.cause_antecedent || '&nbsp;'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Underlying Cause:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.cause_underlying || '&nbsp;'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Manner of Death:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.manner || '&nbsp;'}</td></tr>
    </table>
  </div>
  <div class="section">
    <div class="section-title">Police Intimation (if MLC)</div>
    <table style="width:100%;border-collapse:collapse;">
      <tr><td style="padding:7px 0;width:220px;font-weight:700;color:#374151;">Police Station:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${visit.police_station || '—'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Police Informed At:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${now}</td></tr>
    </table>
  </div>
  <div class="sig-row">
    <div><div class="sig-box">Certifying Doctor<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Medical Superintendent<br><span style="font-size:10px;color:#94a3b8;">Signature & Stamp</span></div></div>
    <div><div class="sig-box">Police Officer<br><span style="font-size:10px;color:#94a3b8;">Name & Badge No.</span></div></div>
  </div>
  <div class="footer-note">City Hospital — Death Certificate / MLC Intimation | Keep original on file</div>
</body></html>`;
    openPrint(html);
}

export function printHandoverNote(patient, visit, form = {}) {
    const now = new Date().toLocaleString('en-PK');
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Handover Note</title><style>${A4_CSS}</style></head><body>
  ${a4Header('Patient Handover Note', `A&E No: ${visit.ae_number || '—'}`)}
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Patient Name</div><div class="val">${patient.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${patient.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${patient.age_years ? patient.age_years+' yrs' : '—'} / ${patient.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">Triage Level</div><div class="val">T${visit.triage_level || '—'} — ${visit.triage_category || '—'}</div></div>
    <div class="info-item"><div class="lbl">Arrival Time</div><div class="val">${visit.arrival_time ? new Date(visit.arrival_time).toLocaleString('en-PK') : '—'}</div></div>
    <div class="info-item"><div class="lbl">Transfer Time</div><div class="val">${now}</div></div>
    <div class="info-item"><div class="lbl">Transferring To</div><div class="val">${form.destination || '—'}</div></div>
    <div class="info-item"><div class="lbl">Receiving Team</div><div class="val">${form.receiving_team || '—'}</div></div>
  </div>
  <div class="section">
    <div class="section-title">Clinical Summary</div>
    <table style="width:100%;border-collapse:collapse;">
      <tr><td style="padding:7px 0;width:200px;font-weight:700;color:#374151;">Chief Complaint:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${visit.chief_complaint || '—'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Working Diagnosis:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.diagnosis || '—'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Treatment Given:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.treatment || '—'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Pending Investigations:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.pending || '—'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Allergies:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.allergies || 'NKDA'}</td></tr>
      <tr><td style="padding:7px 0;font-weight:700;color:#374151;">Special Notes:</td><td style="padding:7px 0;border-bottom:1px solid #e2e8f0;">${form.notes || '—'}</td></tr>
    </table>
  </div>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:30px;margin-top:40px;">
    <div><div class="sig-box">Handing Over Doctor (A&E)<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
    <div><div class="sig-box">Receiving Doctor / Team<br><span style="font-size:10px;color:#94a3b8;">Name: ___________________</span></div></div>
  </div>
  <div class="footer-note">City Hospital — Patient Handover Note</div>
</body></html>`;
    openPrint(html);
}

export function printDischargeSlip(admission) {
    const now = new Date();
    const printDate = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const printTime = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });
    const admitDate = admission.admission_time ? new Date(admission.admission_time).toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' }) : '—';
    const dischargeDate = admission.discharge_time ? new Date(admission.discharge_time).toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' }) : printDate;
    const days = admission.days_admitted || 0;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<style>${SLIP_CSS}</style></head><body>
  ${header('Discharge Summary Slip')}
  <div class="line"></div>
  <div class="center" style="font-size:14px; font-weight:900; margin:4px 0; letter-spacing:1px;">[ DISCHARGE SUMMARY ]</div>
  <div class="mrn-box">
    <div style="font-size:11px; font-weight:700;">Admission No.</div>
    <div style="font-size:18px; font-weight:900; letter-spacing:1px;">${admission.admission_number || '—'}</div>
    <div style="font-size:11px; font-weight:700;">MRN: ${admission.mrn || '—'}</div>
  </div>
  ${admission.admission_number ? barcodeBlock('bc-discharge', admission.admission_number) : ''}
  <div class="dashed"></div>
  <div class="row"><span>Patient:</span><span>${admission.full_name || '—'}</span></div>
  <div class="row"><span>Gender:</span><span>${admission.gender || '—'}</span></div>
  <div class="row"><span>Age:</span><span>${admission.age_years ? admission.age_years + ' Years' : '—'}</span></div>
  ${admission.blood_group ? `<div class="row"><span>Blood Group:</span><span>${admission.blood_group}</span></div>` : ''}
  ${admission.phone ? `<div class="row"><span>Phone:</span><span>${admission.phone}</span></div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Ward:</span><span>${admission.ward_name || '—'}</span></div>
  <div class="row"><span>Bed:</span><span>${admission.bed_number || '—'}</span></div>
  <div class="row"><span>Doctor:</span><span>${admission.admitting_doctor || '—'}</span></div>
  <div class="row"><span>Admit Date:</span><span>${admitDate}</span></div>
  <div class="row"><span>Discharge Date:</span><span>${dischargeDate}</span></div>
  <div class="row"><span>LOS:</span><span>${days} Day(s)</span></div>
  <div class="dashed"></div>
  <div style="font-weight:900; margin-bottom:4px; font-size:12px;">Primary Diagnosis:</div>
  <div style="font-size:12px; font-weight:700; margin-bottom:6px;">${admission.diagnosis || '—'}</div>
  ${admission.discharge_type ? `<div class="row"><span>Discharge Type:</span><span>${admission.discharge_type}</span></div>` : ''}
  ${admission.discharge_summary ? `<div class="dashed"></div><div style="font-weight:900; margin-bottom:4px; font-size:12px;">Summary / Instructions:</div><div style="font-size:11px; font-weight:700;">${admission.discharge_summary}</div>` : ''}
  <div class="dashed"></div>
  <div class="row"><span>Print Date:</span><span>${printDate}</span></div>
  <div class="row"><span>Print Time:</span><span>${printTime}</span></div>
  <div class="line"></div>
  <div class="center" style="font-size:12px; font-weight:700; margin-top:4px;">Follow-up as advised by your doctor</div>
  <div class="center" style="font-size:11px; margin-top:6px;">City Hospital — Hospital Information Management System</div>
</body></html>`;
    openPrint(html);
}

export function printRadiologyReport(order) {
    const now = new Date();
    const printDate = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const printTime = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">${JSBARCODE_SCRIPT}<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: Arial, sans-serif; font-size: 13px; color: #000; padding: 20px; background: #fff; }
  .header { text-align: center; border-bottom: 3px solid #000; padding-bottom: 12px; margin-bottom: 16px; }
  .hospital { font-size: 22px; font-weight: 900; letter-spacing: 1px; }
  .subtitle { font-size: 12px; font-weight: 700; color: #444; margin-top: 3px; }
  .report-title { font-size: 16px; font-weight: 900; text-align: center; margin: 12px 0; letter-spacing: 1px; text-transform: uppercase; border: 2px solid #000; padding: 6px; }
  .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px 20px; background: #f5f5f5; border: 1px solid #ccc; padding: 12px; border-radius: 4px; margin-bottom: 14px; }
  .info-item .lbl { font-size: 10px; font-weight: 700; color: #555; text-transform: uppercase; }
  .info-item .val { font-size: 13px; font-weight: 700; color: #000; }
  .section-title { font-size:11px; font-weight:700; color:#fff; background:#1e3a5f; padding:4px 10px; text-transform:uppercase; letter-spacing:.5px; margin: 14px 0 8px; }
  .section-body { font-size: 13px; line-height: 1.8; min-height: 80px; padding: 10px; border: 1px solid #ccc; border-radius: 4px; white-space: pre-wrap; }
  .sig-row { display: flex; justify-content: space-between; margin-top: 40px; }
  .sig-box { text-align: center; width: 200px; }
  .sig-line { border-top: 2px solid #000; padding-top: 6px; font-size: 12px; font-weight: 700; }
  .footer { text-align: center; font-size: 11px; color: #555; border-top: 1px solid #ccc; margin-top: 20px; padding-top: 8px; }
  @media print { @page { size: A4; margin: 15mm; } body { padding: 0; } }
</style></head><body>
  <div class="header">
    <div class="hospital">🏥 City Hospital</div>
    <div class="subtitle">Hospital Information Management System</div>
    <div class="subtitle">Radiology Department</div>
  </div>
  <div class="report-title">Radiology Report</div>
  <div class="info-grid">
    <div class="info-item"><div class="lbl">Patient Name</div><div class="val">${order.full_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">MRN</div><div class="val">${order.mrn || '—'}</div></div>
    <div class="info-item"><div class="lbl">Age / Gender</div><div class="val">${order.age_years || '?'}y / ${order.gender || '—'}</div></div>
    <div class="info-item"><div class="lbl">Order Number</div><div class="val">${order.order_number || '—'}</div></div>
    <div class="info-item" style="grid-column:1/-1;">${order.order_number ? barcodeBlock('bc-rad-report', order.order_number) : ''}</div>
    <div class="info-item"><div class="lbl">Modality</div><div class="val">${order.modality || '—'}</div></div>
    <div class="info-item"><div class="lbl">Study / Exam</div><div class="val">${order.test_name || order.body_part || '—'}</div></div>
    <div class="info-item"><div class="lbl">Radiologist</div><div class="val">${order.radiologist_name || '—'}</div></div>
    <div class="info-item"><div class="lbl">Approved By</div><div class="val">${order.approved_by_name || '—'}</div></div>
  </div>
  ${order.clinical_indication ? `<div style="font-size:12px; font-weight:700; margin-bottom:10px;"><span style="text-transform:uppercase; color:#555;">Clinical Indication:</span> ${order.clinical_indication}</div>` : ''}
  <div class="section-title">Findings</div>
  <div class="section-body">${order.findings || 'No findings recorded.'}</div>
  <div class="section-title">Impression / Conclusion</div>
  <div class="section-body">${order.impression || 'No impression recorded.'}</div>
  ${order.approval_notes ? `<div class="section-title">Approval Notes</div><div class="section-body" style="min-height:40px;">${order.approval_notes}</div>` : ''}
  <div class="sig-row">
    <div class="sig-box"><div class="sig-line">Radiologist<br/>${order.radiologist_name || '—'}</div></div>
    <div class="sig-box"><div class="sig-line">Approved By<br/>${order.approved_by_name || '—'}</div></div>
  </div>
  <div class="footer">Printed: ${printDate} ${printTime} &nbsp;|&nbsp; City Hospital — Hospital Information Management System</div>
</body></html>`;
    openPrint(html);
}

export function printRadiologyReceipt(order, billingForm) {
    const now = new Date();
    const date = now.toLocaleDateString('en-PK', { day: '2-digit', month: 'short', year: 'numeric' });
    const time = now.toLocaleTimeString('en-PK', { hour: '2-digit', minute: '2-digit' });
    const price = Number(billingForm.price || 0).toLocaleString();
    const disc = billingForm.discount_percent > 0 ? `${billingForm.discount_percent}%` : '—';
    const net = Number(billingForm.net_amount || 0).toLocaleString();
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>${SLIP_CSS}</style></head><body>
  ${header('Payment Receipt')}
  <div class="line"></div>
  <div class="order-box">
    <div style="font-size:11px; font-weight:700;">Order Number</div>
    <div style="font-size:18px; font-weight:900; letter-spacing:1px;">${order.order_number}</div>
  </div>
  <div class="dashed"></div>
  <div class="row"><span>Patient:</span><span>${order.full_name || '—'}</span></div>
  <div class="row"><span>MRN:</span><span>${order.mrn || '—'}</span></div>
  <div class="row"><span>Modality:</span><span>${order.modality || '—'}</span></div>
  <div class="row"><span>Exam:</span><span>${order.test_name || '—'}</span></div>
  <div class="dashed"></div>
  <div class="row"><span>Price (Rs.):</span><span>${price}</span></div>
  <div class="row"><span>Discount:</span><span>${disc}</span></div>
  <div class="dashed"></div>
  <div class="row" style="font-weight:900; font-size:15px;"><span>NET AMOUNT:</span><span>Rs. ${net}</span></div>
  <div class="row"><span>Payment Method:</span><span>${billingForm.payment_method || '—'}</span></div>
  <div class="row"><span>Status:</span><span style="font-weight:700;">${billingForm.payment_status}</span></div>
  <div class="dashed"></div>
  <div class="row"><span>Date:</span><span>${date}</span></div>
  <div class="row"><span>Time:</span><span>${time}</span></div>
  <div class="line"></div>
  <div class="center" style="font-size:12px; font-weight:700; margin-top:4px;">Thank you — City Hospital</div>
</body></html>`;
    openPrint(html);
}

export function printIPDDeathCertificate(admission, form = {}) {
    const printDate = new Date().toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' });
    const admDate = admission.admission_date ? new Date(admission.admission_date).toLocaleString('en-PK', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '—';
    const deathDateTime = `${form.death_date ? new Date(form.death_date).toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' }) : printDate}${form.death_time ? ', ' + form.death_time : ''}`;
    const nokName = admission.next_of_kin_name || '—';
    const nokRelation = admission.next_of_kin_relation || '';
    const nokPhone = form.nok_phone || admission.next_of_kin_contact || '—';
    const doctorName = admission.doctor_name || form.doctor_name || '—';
    const causeText = form.cause_of_death || 'Not specified';
    const placeText = form.place_of_death || admission.ward_name || 'Hospital';
    const statement = `This is to certify that the above-named patient, <strong>${admission.full_name || '—'}</strong> (MR No.: ${admission.mrn || '—'}), was admitted to this hospital on ${admDate} and was declared deceased on ${deathDateTime} at ${placeText}. The cause of death has been recorded as <strong>${causeText}</strong>.`;

    const css = `
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family: Arial, sans-serif; max-width: 760px; margin: 0 auto; padding: 24px 32px; color: #111; background:#fff; font-size:12px; }
      .header { text-align:center; border-bottom:2px solid #000; border-top:4px solid #000; padding-bottom:10px; margin-bottom:14px; }
      .hosp-name { font-size:18px; font-weight:900; color:#000; letter-spacing:0.5px; }
      .hosp-sub { font-size:11px; color:#333; margin-top:3px; }
      .doc-label { font-size:11px; color:#333; margin-top:8px; }
      .doc-title { font-size:16px; font-weight:900; color:#000; margin-top:2px; letter-spacing:1px; text-transform:uppercase; text-decoration:underline; }
      .section-block { border:1px solid #ccc; margin-bottom:10px; }
      .section-header { background:#1e3a5f; color:#fff; font-size:11px; font-weight:700; padding:4px 10px; letter-spacing:0.5px; text-transform:uppercase; }
      .section-body { padding:8px 12px; }
      .row { display:flex; margin-bottom:5px; font-size:12px; }
      .row-half { display:grid; grid-template-columns:1fr 1fr; gap:4px 0; }
      .lbl { color:#000; font-weight:400; min-width:160px; flex-shrink:0; }
      .lbl::after { content:' :'; }
      .val { font-weight:700; color:#000; }
      .cause-box { border:1px solid #000; min-height:80px; padding:8px; font-size:12px; line-height:1.6; margin-top:6px; font-weight:700; }
      .statement-text { font-size:12px; line-height:1.8; }
      .sig-row { display:grid; grid-template-columns:1fr 1fr; gap:60px; margin-top:36px; padding:0 10px; }
      .sig-box { text-align:center; }
      .sig-line { border-top:1px solid #000; margin-bottom:4px; }
      .sig-title { font-size:11px; font-weight:700; }
      .sig-sub { font-size:10px; color:#333; margin-top:3px; }
      .footer { text-align:center; font-size:10px; color:#555; margin-top:16px; border-top:1px solid #ccc; padding-top:6px; font-style:italic; }
      @media print { @page { size:A4; margin:12mm; } body { padding:0; } }
    `;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Death Certificate</title><style>${css}</style></head><body>
  <div class="header">
    <div class="hosp-name">City Hospital</div>
    <div class="hosp-sub">Inpatient Department</div>
    <div class="doc-label">Hospital Death Certificate</div>
    <div class="doc-title">Death Certificate</div>
  </div>

  <div class="section-block">
    <div class="section-header">Certificate / Admission Information</div>
    <div class="section-body">
      <div class="row-half">
        <div class="row"><span class="lbl">Admission No</span><span class="val">${admission.admission_number || '—'}</span></div>
        <div class="row"><span class="lbl">Token / MR No</span><span class="val">${admission.mrn || '—'}</span></div>
        <div class="row"><span class="lbl">Date of Arrival</span><span class="val">${admDate}</span></div>
        <div class="row"><span class="lbl">Unit / Ward</span><span class="val">${admission.ward_name || '—'}</span></div>
        <div class="row"><span class="lbl">Date &amp; Time of Death</span><span class="val">${deathDateTime}</span></div>
        <div class="row"><span class="lbl">Consultant I/C</span><span class="val">${doctorName}</span></div>
        <div class="row"><span class="lbl">MR No</span><span class="val">${admission.mrn || '—'}</span></div>
        <div class="row"><span class="lbl">Date Printed</span><span class="val">${printDate}</span></div>
      </div>
    </div>
  </div>

  <div class="section-block">
    <div class="section-header">Patient Details</div>
    <div class="section-body">
      <div class="row-half">
        <div class="row"><span class="lbl">Name of Patient</span><span class="val">${admission.full_name || '—'}</span></div>
        <div class="row"><span class="lbl">Age at Death</span><span class="val">${admission.age || '—'}</span></div>
        <div class="row"><span class="lbl">Gender</span><span class="val">${admission.gender || '—'}</span></div>
        <div class="row"><span class="lbl">CNIC No</span><span class="val">${admission.cnic || '—'}</span></div>
        <div class="row"><span class="lbl">Nationality</span><span class="val">${admission.nationality || 'Pakistani'}</span></div>
        <div class="row"><span class="lbl">Religion</span><span class="val">${admission.religion || '—'}</span></div>
      </div>
      <div class="row" style="margin-top:3px;"><span class="lbl">Address</span><span class="val">${admission.address || '—'}</span></div>
    </div>
  </div>

  <div class="section-block">
    <div class="section-header">Next of Kin</div>
    <div class="section-body">
      <div class="row-half">
        <div class="row"><span class="lbl">Name</span><span class="val">${nokName}${nokRelation ? ' (' + nokRelation + ')' : ''}</span></div>
        <div class="row"><span class="lbl">Phone</span><span class="val">${nokPhone}</span></div>
      </div>
    </div>
  </div>

  <div class="section-block">
    <div class="section-header">Statement</div>
    <div class="section-body">
      <div class="statement-text">${statement}</div>
    </div>
  </div>

  <div class="section-block">
    <div class="section-header">Cause of Death (Details)</div>
    <div class="section-body">
      <div class="cause-box">${causeText}${form.summary ? '<br><br>' + form.summary : ''}</div>
    </div>
  </div>

  <div class="sig-row">
    <div class="sig-box"><div class="sig-line"></div><div class="sig-title">Doctor In-Charge</div><div class="sig-sub">Name: ____________________________</div><div class="sig-sub">Reg. No: _________________________</div></div>
    <div class="sig-box"><div class="sig-line"></div><div class="sig-title">Administrative Officer / Authorized Signatory</div><div class="sig-sub">Signature &amp; Stamp</div></div>
  </div>

  <div class="footer">These particulars are based on hospital records and information provided by attendants. The hospital shall not be responsible for any misrepresentation.<br>City Hospital — Death Certificate | Admission No: ${admission.admission_number || '—'} | Keep original on file</div>
</body></html>`;
    openPrint(html);
}

export function printIPDDischargeSummary(admission, form = {}, medications = [], labOrders = [], radiologyOrders = []) {
    const printDate = new Date().toLocaleDateString('en-PK', { day:'2-digit', month:'short', year:'numeric' });
    const printTime = new Date().toLocaleTimeString('en-PK', { hour:'2-digit', minute:'2-digit' });
    const admDate = admission.admission_date ? new Date(admission.admission_date).toLocaleString('en-PK', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '—';
    const dischargeDate = new Date().toLocaleString('en-PK', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' });
    const los = admission.admission_date ? Math.ceil((new Date() - new Date(admission.admission_date)) / (1000*60*60*24)) : '—';
    const esc = (s) => (s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>');

    // Medication lines — plain text style like SICVD
    const medLines = medications.length
        ? medications.map(m => `TAB: ${(m.medicine_name||'').toUpperCase()} ${m.dose||''} ${m.frequency||''} ${m.route ? '('+m.route+')' : ''}`.trim()).join('\n')
        : (form.medication_on_discharge || '');

    // Lab & Radiology bullet lists
    const labItems = labOrders.length ? labOrders.map(l => l.test_name || l.order_name || 'Lab Test') : [];
    const radItems = radiologyOrders.length ? radiologyOrders.map(r => ((r.modality||'') + ' ' + (r.body_part || r.study_type || '')).trim()) : [];

    // IPD services (dummy for testing)
    const ipdServices = [
        { name: 'Oxygen Cylinder', qty: 2 },
        { name: 'Nursing Care', qty: los || 1 },
        { name: 'Nebulization', qty: 3 },
    ];

    const css = `
      * { margin:0; padding:0; box-sizing:border-box; }
      body { font-family: Arial, sans-serif; max-width: 750px; margin: 0 auto; padding: 18px 24px; color: #000; background:#fff; font-size:12px; }

      /* ── HEADER ── */
      .hdr-wrap { display:flex; align-items:center; justify-content:center; margin-bottom:6px; }
      .hdr-logo { width:64px; height:64px; margin-right:16px; border:1px solid #ccc; display:flex; align-items:center; justify-content:center; color:#aaa; font-size:9px; flex-shrink:0; }
      .hdr-text { text-align:center; }
      .hosp-name { font-size:18px; font-weight:900; text-transform:uppercase; letter-spacing:.5px; }
      .hosp-sub { font-size:11px; color:#444; margin-top:2px; }
      .doc-title { font-size:15px; font-weight:900; text-transform:uppercase; margin-top:4px; text-decoration:underline; letter-spacing:.5px; }
      .print-info { font-size:10px; color:#333; text-align:right; margin-bottom:4px; }

      /* ── PATIENT TABLE ── */
      table.pt { width:100%; border-collapse:collapse; border:1px solid #888; margin-bottom:12px; }
      table.pt td { border:1px solid #888; padding:4px 8px; font-size:11px; }
      table.pt td.lbl { font-weight:700; width:130px; background:#f5f5f5; }
      table.pt td.val { font-weight:400; }

      /* ── SECTIONS (blue bar header + content below) ── */
      .s { margin-bottom:8px; page-break-inside:avoid; }
      .s-lbl { font-weight:700; font-size:11px; background:#1e3a5f; color:#fff; padding:4px 10px; margin-bottom:4px; text-transform:uppercase; letter-spacing:.5px; }
      .s-val { font-size:12px; line-height:1.6; white-space:pre-wrap; padding:2px 10px; min-height:18px; }
      .s-empty { color:#bbb; font-style:italic; }

      /* ── TWO-COL ── */
      .two-col { display:grid; grid-template-columns:1fr 1fr; gap:0 20px; }

      /* ── BULLET LIST ── */
      ul.blist { margin:0; padding:0 0 0 18px; }
      ul.blist li { margin-bottom:2px; font-size:12px; }

      /* ── IPD SERVICES TABLE ── */
      table.svc { width:100%; border-collapse:collapse; font-size:11px; margin-top:2px; }
      table.svc th { background:#e8edf3; border:1px solid #ccc; padding:4px 8px; font-weight:700; text-align:left; }
      table.svc td { padding:4px 8px; border:1px solid #ddd; }

      /* ── SIGNATURE ── */
      .sig-wrap { display:flex; justify-content:space-between; margin-top:32px; padding:0 8px; }
      .sig-box { min-width:200px; }
      .sig-line { border-top:1px solid #000; margin-bottom:3px; }
      .sig-lbl { font-size:11px; font-weight:700; }
      .sig-sub { font-size:10px; color:#444; margin-top:2px; }

      @media print { @page { size:A4 portrait; margin:10mm 12mm; } body { padding:0; max-width:100%; } }
    `;

    // Helper: value or empty string (no fallback dash — SICVD leaves blank)
    const v = (val) => esc(val) || '';
    const vOrDash = (val) => esc(val) || '—';

    const admTime = admission.admission_date ? new Date(admission.admission_date).toLocaleTimeString('en-PK', { hour:'2-digit', minute:'2-digit' }) : '—';
    const admDateOnly = admission.admission_date ? new Date(admission.admission_date).toLocaleDateString('en-PK', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
    const dischDateOnly = new Date().toLocaleDateString('en-PK', { day:'2-digit', month:'2-digit', year:'numeric' });
    const dischTime = new Date().toLocaleTimeString('en-PK', { hour:'2-digit', minute:'2-digit' });

    const section = (label, content) => `
  <div class="s">
    <div class="s-lbl">${label}</div>
    <div class="s-val">${content || '<span class="s-empty">&nbsp;</span>'}</div>
  </div>`;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Discharge Summary</title><style>${css}</style></head><body>

  <div class="print-info">Print Date: ${printDate} ${printTime} &nbsp;|&nbsp; Printed By: ${vOrDash(admission.doctor_name)}</div>

  <div class="hdr-wrap">
    <div class="hdr-logo">LOGO</div>
    <div class="hdr-text">
      <div class="hosp-name">City Hospital</div>
      <div class="hosp-sub">Inpatient Department</div>
      <div class="doc-title">Discharge Summary</div>
    </div>
  </div>

  <table class="pt">
    <tr>
      <td class="lbl">Admission No.</td><td class="val">${vOrDash(admission.admission_number)}</td>
      <td class="lbl">Admission Date</td><td class="val">${admDateOnly}</td>
    </tr>
    <tr>
      <td class="lbl">Admission Time</td><td class="val">${admTime}</td>
      <td class="lbl">Discharge Date</td><td class="val">${dischDateOnly}</td>
    </tr>
    <tr>
      <td class="lbl">Discharge Time</td><td class="val">${dischTime}</td>
      <td class="lbl">Consultant Name</td><td class="val">${vOrDash(admission.doctor_name)}</td>
    </tr>
    <tr>
      <td class="lbl">Patient Name</td><td class="val">${vOrDash(admission.full_name)}</td>
      <td class="lbl">Registration No.</td><td class="val">${vOrDash(admission.mrn)}</td>
    </tr>
    <tr>
      <td class="lbl">Gender</td><td class="val">${vOrDash(admission.gender)}</td>
      <td class="lbl">Age</td><td class="val">${vOrDash(admission.age)}</td>
    </tr>
    <tr>
      <td class="lbl">Ward / Department</td><td class="val" colspan="3">${vOrDash(admission.ward_name)}${admission.bed_number ? ' — Bed ' + admission.bed_number : ''}</td>
    </tr>
  </table>

  ${section('Diagnosis', v(form.diagnosis))}
  ${section('Presenting Complaints', v(form.presenting_complaints))}
  ${section('Hospital Course', v(form.hospital_course))}
  ${section('Relevant Investigation', v(form.relevant_investigations))}
  ${section('Date of Surgery', v(form.surgery_date))}
  ${section('Operative Procedure', v(form.operative_procedure))}
  ${section('Pending Reports', v(form.pending_reports))}

  <div class="s">
    <div class="s-lbl">Lab Tests Issued</div>
    ${labItems.length ? `<ul class="blist">${labItems.map(i=>`<li>${esc(i)}</li>`).join('')}</ul>` : '<div class="s-val">&nbsp;</div>'}
  </div>

  <div class="s">
    <div class="s-lbl">Radiology Tests Issued</div>
    ${radItems.length ? `<ul class="blist">${radItems.map(i=>`<li>${esc(i)}</li>`).join('')}</ul>` : '<div class="s-val">&nbsp;</div>'}
  </div>

  <div class="s">
    <div class="s-lbl">IPD Services Used <span style="font-size:10px;font-weight:400;color:#888;">(dummy data — for testing)</span></div>
    <table class="svc">
      <thead><tr><th>Service</th><th>Qty</th></tr></thead>
      <tbody>${ipdServices.map(s=>`<tr><td>${s.name}</td><td>${s.qty}</td></tr>`).join('')}</tbody>
    </table>
  </div>

  ${section('Instruction on Discharge', v(form.discharge_instructions))}
  ${section('Medication on Discharge', v(medLines || form.medication_on_discharge))}
  ${section('Follow-up', [form.follow_up_date && ('Date: ' + form.follow_up_date), form.follow_up_department && ('Dept / Doctor: ' + form.follow_up_department)].filter(Boolean).join('\n'))}
  ${section('Condition on Discharge', v(form.condition_on_discharge))}
  ${section('Additional Comments / Summary', v(form.additional_comments))}

  <div class="sig-wrap">
    <div class="sig-box">
      <div class="sig-line"></div>
      <div class="sig-lbl">Discharged By: ${vOrDash(admission.doctor_name)}</div>
      <div class="sig-sub">Signature: ____________________________</div>
    </div>
    <div class="sig-box" style="text-align:center;">
      <div class="sig-line"></div>
      <div class="sig-lbl">Consultant / Doctor In-Charge</div>
      <div class="sig-sub">Name &amp; Stamp</div>
    </div>
  </div>

</body></html>`;
    openPrint(html);
}

